<!--
 * @Description: 档案审批
 * @Author: ma.cq
 * @Date: 2019-11-08 16:37:43
 * @LastEditors: Tina
 * @LastEditTime: 2023-01-10 09:49:48
 -->
<template>
  <el-dialog
    title="审核"
    :visible.sync="show"
    width="850px"
    @close="handleClose">
    <info-form :info="info"/>
    <div class="line"></div>
    <el-form :model="form" :rules="rules" ref="form" label-width="100px">
      <el-form-item label="审核结果" prop="status">
        <el-radio-group v-model="form.status">
          <el-radio v-for="item in statusOptions" :key="item.label" :label="item.label">
            {{item.title}}
          </el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="备注" prop="remark" :rules="{required: requiredReamrk, message: '请输入备注'}">
        <el-input v-model="form.remark" type="textarea"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="handleSubmit">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { mapActions } from 'vuex'
import InfoForm from './components/infoForm'

export default {
  name: 'VerifyDialog',
  components: { InfoForm },
  props: ['show', 'info'],
  data () {
    return {
      form: {
        status: '',
        remark: ''
      },
      rules: {
        status: [
          { required: true, message: '请选择审核结果' }
        ]
      },
      statusOptions: [
        {
          label: 2,
          title: '通过'
        },
        {
          label: 3,
          title: '不通过'
        }
      ]
    }
  },
  computed: {
    requiredReamrk () {
      return this.form.status === 3
    }
  },
  methods: {
    ...mapActions(['verifyCustomerArchivesApproval', 'getCustomerArchivesApprovalList']),
    handleSubmit () {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.verify()
        } else {
          return false
        }
      })
    },
    verify () {
      const params = {
        ...this.form,
        accountId: this.info.accountId,
        id: this.info.id
      }
      this.verifyCustomerArchivesApproval(params).then(() => {
        this.$message.success('审核成功')
        this.getCustomerArchivesApprovalList()
        this.handleClose()
      })
    },
    handleClose () {
      this.$emit('update:show', false)
    }
  },
  watch: {
    show (newVal) {
      if (newVal) {
        this.form = {
          status: '',
          remark: ''
        }
        this.$nextTick(() => {
          this.$refs.form.clearValidate()
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.line {
  width: 100%;
  height: 0;
  border-top: 1px solid #eee;
  margin: 30px 0;
}
</style>
